var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99999 9.99999C4.99999 9.89999 5.09999 9.69999 5.19999 9.59999L14.1 0.699988C14.3 0.499988 14.7 0.499988 14.9 0.699988C15.1 0.899988 15.1 1.29999 14.9 1.49999L6.39999 9.99999L14.9 18.5C15.1 18.7 15.1 19.1 14.9 19.3C14.7 19.5 14.3 19.5 14.1 19.3L5.19999 10.4C5.09999 10.3 4.99999 10.1 4.99999 9.99999Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.0d81a9586c2113979305b277b7be8a27.svg";
export { ForwardRef as ReactComponent };